import React, {ReactElement} from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  CardContent,
  makeStyles,
  Typography
} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import PhoneNumberFormatter from '@components/system/PhoneNumberFormatter/PhoneNumberFormatter';
import {Coverage} from '../EligibilityVerificationMapper';
import KeyValueCard from '@components/system/KeyValueCard/KeyValueCard';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {CARD_BOX_SHADOW} from 'src/style/variable';

const styles = makeStyles(() => ({
  cardRoot: {
    '& .MuiCardContent-root:last-child': {
      paddingBottom: '13px'
    },
    flex: 1,
    boxShadow: CARD_BOX_SHADOW,
    borderRadius: '1rem'
  },
  fullHeight: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  title: {
    fontSize: '1.3rem',
    fontWeight: 600
  },
  benefitAccordionSummary: {
    flexDirection: 'row-reverse',
    paddingLeft: 0,
    '& .MuiAccordionSummary-content': {
      marginLeft: '1rem'
    }
  }
}));

interface InsurancePayerDetailsCardInterface {
  coverage: Coverage;
}

const InsurancePayerDetailsCard = (
  props: InsurancePayerDetailsCardInterface
): ReactElement => {
  const classes = styles();
  const {coverage} = props;
  const {t} = useTranslation();
  const payerData = [
    {
      label: t('ELIGIBILITY_VERIFICATION.PAYER_ID'),
      value: coverage?.payer_id ? coverage.payer_id : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.NAME'),
      value: coverage?.payer_name ? coverage.payer_name : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.GROUP_NAME'),
      value: coverage?.payer_group_name ? coverage?.payer_group_name : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.GROUP_NUMBER'),
      value: coverage?.payer_group_number ? coverage?.payer_group_number : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.PLAN_NAME'),
      value: coverage?.payer_plan_name ? coverage?.payer_plan_name : '-'
    },
    {
      label: t('ELIGIBILITY_VERIFICATION.PLAN_NUMBER'),
      value: coverage?.payer_plan_number ? coverage?.payer_plan_number : '-'
    }
  ];

  if (
    coverage?.payer_contact_information &&
    Array.isArray(coverage.payer_contact_information) &&
    coverage.payer_contact_information.length > 0
  ) {
    const payerContactData = [
      {
        label: t('ELIGIBILITY_VERIFICATION.PHONE'),
        value: coverage?.payer_contact_information[0]?.phone ? (
          <PhoneNumberFormatter
            value={coverage.payer_contact_information[0].phone}
          />
        ) : (
          '-'
        )
      },
      {
        label: t('ELIGIBILITY_VERIFICATION.EMAIL'),
        value: coverage?.payer_contact_information[0]?.emailAddress
          ? coverage.payer_contact_information[0].emailAddress
          : '-'
      },
      {
        label: t('ELIGIBILITY_VERIFICATION.WEBSITE'),
        value: coverage?.payer_contact_information[0]?.url
          ? coverage.payer_contact_information[0].url
          : '-'
      }
    ];
    payerData.push(...payerContactData);
  }
  return (
    <div className={`section-header ${classes.fullHeight}`}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className={classes.benefitAccordionSummary}>
          <Typography className={classes.title}>
            {t('ELIGIBILITY_VERIFICATION.PAYER')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Card className={`${classes.cardRoot} card`}>
            <CardContent>
              <KeyValueCard data={payerData} />
            </CardContent>
          </Card>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default InsurancePayerDetailsCard;
